import { FC, useLayoutEffect } from 'react';
import { Watermark } from 'watermark-js-plus';

export interface IWithWatermarkProps {
  content: string;
  targetElementId: string;
  children: React.ReactNode;
}

const WithWatermark: FC<IWithWatermarkProps> = ({
  content,
  targetElementId,
  children,
}: IWithWatermarkProps) => {
  useLayoutEffect(() => {
    const target = document.getElementById(targetElementId);
    if (!target) {
      return;
    }

    target.style.position = 'relative';

    const watermark = new Watermark({
      content,
      width: 200,
      height: 200,
      parent: target,
    });
    watermark.create();

    return () => {
      watermark.destroy();
    };
  }, [content, targetElementId]);

  return children;
};

export default WithWatermark;
